/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountSecurednessOutput
 */
export interface AccountSecurednessOutput {
    /**
     * 
     * @type {string}
     * @memberof AccountSecurednessOutput
     */
    accountGuid: string;
    /**
     * 
     * @type {number}
     * @memberof AccountSecurednessOutput
     */
    initialSecuredness: number;
    /**
     * 
     * @type {number}
     * @memberof AccountSecurednessOutput
     */
    targetSecuredness: number;
}

/**
 * Check if a given object implements the AccountSecurednessOutput interface.
 */
export function instanceOfAccountSecurednessOutput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "accountGuid" in value;
    isInstance = isInstance && "initialSecuredness" in value;
    isInstance = isInstance && "targetSecuredness" in value;

    return isInstance;
}

export function AccountSecurednessOutputFromJSON(json: any): AccountSecurednessOutput {
    return AccountSecurednessOutputFromJSONTyped(json, false);
}

export function AccountSecurednessOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountSecurednessOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accountGuid': json['account_guid'],
        'initialSecuredness': json['initial_securedness'],
        'targetSecuredness': json['target_securedness'],
    };
}

export function AccountSecurednessOutputToJSON(value?: AccountSecurednessOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account_guid': value.accountGuid,
        'initial_securedness': value.initialSecuredness,
        'target_securedness': value.targetSecuredness,
    };
}

